import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './PositionFields.css'

const months = process.env.REACT_APP_MONTHS.split(',')

const PositionFields = ({ isAuthorized, position, standalone }) => {
  const positionFieldsClassNames = classNames('PositionFields', {
    PositionFields__md: !standalone,
  })

  let attrs

  // Decide which attributes to show
  if (isAuthorized) {
    attrs = [
      ['description', 'Office Description'],
      ['salary', 'Position Salary'],
      ['employment_type', 'Part Time or Full Time'],
      ['eligibility_requirements', 'Eligibility Requirements'],
      ['paperwork_instructions', 'Filing Instructions'],
    ]
  } else {
    attrs = [
      ['description', 'Office Description'],
      ['salary', 'Position Salary'],
      ['employment_type', 'Part Time or Full Time'],
      ['eligibility_requirements', 'Eligibility Requirements'],
      ['paperwork_instructions', 'Filing Instructions'],
    ]
  }

  // Add filing date depending on which attribute is set
  if (
    position.primary_filing_end &&
    position.primary_filing_end.length > 0 &&
    position.primary_filing_end !== 'n/a'
  ) {
    attrs.push(['primary_filing_end', 'Filing Deadline'])
  } else if (
    position.general_filing_end &&
    position.general_filing_end.length > 0
  ) {
    attrs.push(['general_filing_end', 'Filing Deadline'])
  } // else ignore

  const fields = attrs.map(([attribute, title], key) => {
    if (!position[attribute]) {
      return null
    }

    let value = position[attribute]

    // Only show month if deadline is not this year
    if (
      (attribute === 'general_filing_end' ||
        attribute === 'primary_filing_end') &&
      value.match(/^\d{4}-\d{2}-\d{2}$/)
    ) {
      let description = ''
      if (attribute === 'primary_filing_end') {
        description = '(Primary Filing)'
      }
      if (attribute === 'general_filing_end') {
        description = '(General Filing)'
      }

      const parsedDate = value.match(/^(\d{4})-(\d{2})-(\d{2}$)/)
      const year = parsedDate[1]
      const monthString = months[Number(parsedDate[2]) - 1]
      const day = parsedDate[3]
      value = `${monthString} ${day}, ${year} ${description}`
    }

    return (
      <div className="row PositionField" key={key}>
        <div className="col-md-3 Position__DataCell">
          <h6>{title}</h6>
        </div>
        <div className="col-md-9 Position__DataCell">{value}</div>
      </div>
    )
  })

  return <div className={positionFieldsClassNames}>{fields}</div>
}

PositionFields.propTypes = {
  isAuthorized: PropTypes.bool,
  position: PropTypes.object.isRequired,
  standalone: PropTypes.bool,
}

PositionFields.defaultProps = {
  isAuthorized: false,
  standalone: false,
}

export default PositionFields



// WEBPACK FOOTER //
// ./src/components/Position/PositionFields/PositionFields.js